module.exports = __webpack_public_path__ + "img/jbt-card2.af285016.jpg";